import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ClassicLayoutNzComponent } from './classic-layout-nz/classic-layout-nz.component';

@NgModule({
  imports: [CommonModule, ClassicLayoutNzComponent],
  exports: [ClassicLayoutNzComponent],
})
export class LayoutsModule {}
